<ion-content color="light">
  <ng-container>
    <ion-grid>
      <ion-row>
        <ion-col size-xs="12" size-xl="6">
          <ion-row>
            <ion-col>
              <rc-page-title
                [title]="cost > 0 ? 'Payment required' : 'Cost covered in your subscription'"
              [showGoToHome]="true"></rc-page-title>
            </ion-col>
          </ion-row>

          @if (cost > 0) {
            <ion-row>
              <ion-col>
                <ion-text>
                  Orders outside of your plan add a shipping fee. Read more below or contact us for help.
                </ion-text>
              </ion-col>
            </ion-row>
          }

          @if (loading) {
            <ion-row>
              @if (loading) {
                <ion-skeleton-text class="price-skeleton" [animated]="true"></ion-skeleton-text>
              }
            </ion-row>
          }

          @if (!loading) {
            <ion-row>
              <ion-col>
                @if (handlingPaymentOfDelivery) {
                  <rc-payment-reason
                  [orderInfo]="deliveryOrderInfo"></rc-payment-reason>
                }
                @if (handlingPaymentOfPickup) {
                  <rc-payment-reason [orderInfo]="pickupOrderInfo"></rc-payment-reason>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-margin-vertical">
                @if (!loading) {
                  <ion-label><h2>Total: {{cost}}.00$</h2></ion-label>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-text-center">
                @if (cost > 0) {
                  <ion-button color="secondary" (click)="pay()">
                    <ion-icon name="card-outline" slot="start"></ion-icon>
                    Proceed with payment
                  </ion-button>
                }
                @if (cost === 0) {
                  <ion-button color="secondary" (click)="promote()">
                    <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
                    Confirm
                  </ion-button>
                }
              </ion-col>
            </ion-row>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>
